export default {
  data() {
    return {
      columns: [
        {
          title: '序号',
          width: 70,
          dataIndex: 'order',
          fixed: 'left',
          align: 'center',
          customRender: (text, record, index) =>
            (this.pageData.current - 1) * this.pageData.pageSize + (index + 1),
        },
        {
          dataIndex: 'name',
          slots: { title: 'customName' },
        },
        {
          title: this.form.year + '本公司',
          dataIndex: 'current',
          scopedSlots: { customRender: 'current' },
        },
        {
          title: this.form.year + '同类均值',
          dataIndex: 'currentAvg',
          scopedSlots: { customRender: 'currentAvg' },
        },
        {
          title: this.form.year - 1 + '本公司',
          dataIndex: 'prev',
          scopedSlots: { customRender: 'prev' },
        },
        {
          title: this.form.year - 1 + '同类均值',
          dataIndex: 'prevAvg',
          scopedSlots: { customRender: 'prevAvg' },
        },
        {
          title: this.form.year - 2 + '本公司',
          dataIndex: 'beforePrev',
          scopedSlots: { customRender: 'beforePrev' },
        },
        {
          title: this.form.year - 2 + '同类均值',
          dataIndex: 'beforePrevAvg',
          scopedSlots: { customRender: 'beforePrevAvg' },
        },
        {
          title: '操作',
          fixed: 'right',
          width: 220,
          dataIndex: 'action',
          slotName: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
      },
    }
  },
  methods: {
    onSelect(checkedKeys, e, index) {
      this[`checkedKeys-${index}`] = checkedKeys
    },
  },
}
